<span *ngIf="row.campaign_id !== null || true">{{ row.campaign_name }}</span>

<app-select
  *ngIf="row.campaign_id == null && false"
  [items]="getItems()"
  (selection)="itemClicked($event)"
  label="Campaign"></app-select>
